const getIconSizeByType = type => {
  if (type === 'large') {
    return 16;
  }
  return 14;
};
export default getIconSizeByType;